import type { FC } from 'react';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import { Button, Stack, Typography } from '@mui/material';

import { routePaths } from 'src/services/routing/routePaths';
import { useUserContext } from 'src/components/app/context/UserContext';

import { styles } from './index.styles';

const PreviousVersionBanner: FC = () => {
  const { t } = useTranslation('common');
  const history = useHistory();
  const { currentSurvey, switchSurvey } = useUserContext();
  const { previousSurvey } = useMemo(
    () => currentSurvey || { previousSurvey: undefined },
    [currentSurvey],
  );

  const onClick = useCallback(() => {
    if (previousSurvey === null || previousSurvey === undefined) return;

    switchSurvey(previousSurvey.id).then(() => history.push(routePaths.START));
  }, [switchSurvey, previousSurvey, history]);

  return previousSurvey ? (
    <Stack direction="row" sx={styles.banner}>
      <Button
        variant="text"
        onClick={onClick}
        endIcon={<ArrowForwardRoundedIcon />}
        sx={styles.previousVersionButton}
      >
        <Typography variant="button2">
          {t('goToSurvey', {
            surveyName: previousSurvey.name,
          })}
        </Typography>
      </Button>
    </Stack>
  ) : null;
};

export default PreviousVersionBanner;
